// Import libraries
import React, { useState } from "react";

// Import components
import { Col, Row } from 'react-bootstrap';
import { DASH_ALG_WerknemersInDeSector } from "../Models/ApiModels";
import { FormatString } from "../Functions/ApiFunctions";
import { ApiBaseURL, ApiUrls } from "../Urls/ApiUrls";

function EmployeesInSector(params: any) {
    var DashboardYear = params.DashboardYear;
    var SectorId = params.SectorId;
    var userGuid = params.rnd;
    var loginGuid = params.lg;

    let obj: DASH_ALG_WerknemersInDeSector[] = [];
    let [aantal, setAantal] = useState(0);
    let [busy, setBusy] = useState(true);

    fetch(FormatString(ApiUrls.DASH_ALG_WerknemersInDeSector, ApiBaseURL, SectorId.toString(), DashboardYear.toString() + "-12-31", loginGuid, userGuid, params.kw))
        .then(response => response.json())
        .then(json => {

            obj = JSON.parse(JSON.stringify(json));

            setAantal(obj.map(item => item.AantalWerknemers).reduce((accumulation, current) => {
                return accumulation + current;
            }, 0));

            setBusy(false);
        }
    );

    if (busy)
    return <></>

    return (
        <>
            <div className="card earth bg-white border border-gray-200 rounded-lg shadow">
                <div className="c-title">
                    <h6 className="mb-0 hfont6">Unieke werknemers in sector <span><i><a className="faq-number" href="#FAQ-4">(4*)</a></i></span></h6>
                </div>
                <Row className="c-row">
                    <Col xs={12} sm={9} xl={7}>
                        <h1 className="mb-0 hfont1">{aantal}</h1>
                    </Col>
                </Row>
            </div>
        </>

    )
}

export default EmployeesInSector;
